import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';

export function getCompanyName(state: RootState) {
    const registered_company_name = _.get(
        state,
        'api.customer_state.data.application.company.registered_company_name'
    );

    const trading_name = _.get(
        state,
        'api.customer_state.data.application.company.trading_name'
    );

    if (registered_company_name) return registered_company_name;
    if (trading_name) return trading_name;
    return '';
}
